import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDeleteVersion } from '../../api/deleteVersion';
import { AccordionListItem } from 'components/Button';
import { Button, Stack, Typography } from '@mui/material';
import { Modal } from 'components/Modal';

export const DeleteVersionButton = ({ versionId, refetch }) => {
  const { id } = useParams();
  const { mutateAsync } = useDeleteVersion(refetch);

  const [open, setOpen] = useState(false);

  const handleCloseModal = () => setOpen(false);

  const handleDelete = () =>
    mutateAsync({
      jobAdID: id,
      versionID: versionId,
    })
      .then(handleCloseModal)
      .catch(() => {});

  return (
    <>
      <AccordionListItem onClick={() => setOpen(true)} sx={{ color: 'error.main' }}>
        Delete
      </AccordionListItem>

      <Modal open={open} handleClose={handleCloseModal} title="Delete version">
        <Typography variant="body1" fontWeight={500}>
          Are you sure you want to delete this version? This action cannot be undone.
        </Typography>

        <Stack direction="row" justifyContent="center" gap={1}>
          <Button variant="outlined" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleDelete}>
            Confirm
          </Button>
        </Stack>
      </Modal>
    </>
  );
};
